module.exports = __webpack_public_path__ + "img/cloud-3.4b365d2f.png";